import { Action } from '@ngrx/store';

export enum OrderActionTypes {
  REQUEST = '[Repeat Order] Request',
  REQUEST_UL = '[Repeat Order] Request UL',
  REQUEST_COMPLETE = '[Repeat Order] Request complete',
  RESET = '[Repeat Order] Reset',
}

export class OrderLoadAction implements Action {
  readonly type = OrderActionTypes.REQUEST;

  constructor() {}
}

export class OrderLoadActionUL implements Action {
  readonly type = OrderActionTypes.REQUEST_UL;

  constructor() {}
}

export class OrderLoadCompleteAction implements Action {
  readonly type = OrderActionTypes.REQUEST_COMPLETE;

  constructor(public payload: any) {}
}

export class OrderResetAction implements Action {
  readonly type = OrderActionTypes.RESET;

  constructor() {}
}

export type OrderActions = OrderLoadAction | OrderLoadCompleteAction | OrderResetAction | OrderLoadActionUL;
